import { render, staticRenderFns } from "./ordonnance.vue?vue&type=template&id=0e5e79a4&scoped=true&"
import script from "./ordonnance.vue?vue&type=script&lang=js&"
export * from "./ordonnance.vue?vue&type=script&lang=js&"
import style0 from "./ordonnance.vue?vue&type=style&index=0&id=0e5e79a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5e79a4",
  null
  
)

export default component.exports